import { render, staticRenderFns } from "./tunnelPromote.vue?vue&type=template&id=679ba984&scoped=true&"
import script from "./tunnelPromote.vue?vue&type=script&lang=js&"
export * from "./tunnelPromote.vue?vue&type=script&lang=js&"
import style0 from "./tunnelPromote.vue?vue&type=style&index=0&id=679ba984&scoped=true&lang=css&"
import style1 from "./tunnelPromote.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ba984",
  null
  
)

export default component.exports